<header class="fm-header">
  <nav class="navbar navbar-expand-md fm-navbar">
    <div class="container-xl">
      <div class="fm-mainlogo">
        <a class="navbar-brand fm-navbar-brand" routerLink="/">
          <img class="fm-logo" src="images/logo.svg" alt="Forever Memories Logo" width="213" />
        </a>
      </div>
      <div class="fm-header-rs">
        <div class="fm-btn-group order-md-2 d-none d-sm-block">
          <a class="fm-common-btn" routerLink="/login">Sign in</a>
        </div>
        <div class="fm-navigation">
          <button class="navbar-toggler fm-navbar-toggler" type="button"
            data-bs-toggle="collapse" data-bs-target="#navbarNavDropdown"
            aria-controls="navbarNavDropdown" aria-expanded="false"
            aria-label="Toggle navigation">
            <span class="navbar-toggler-icon fm-navbar-toggler-icon"></span>
          </button>
          <div class="collapse navbar-collapse fm-navbar-collapse" id="navbarNavDropdown">
            <ul class="navbar-nav fm-header-links">
              <li class="nav-item fm-nav-item">
                <a class="nav-link fm-nav-link" href="#fmFeatures">Features</a>
              </li>
              <li class="nav-item fm-nav-item">
                <a class="nav-link fm-nav-link" href="#fmHowItWorks">How it Works</a>
              </li>
              <li class="nav-item fm-nav-item">
                <a class="nav-link fm-nav-link" href="#fmStories">Stories</a>
              </li>
            </ul>
            <div class="fm-btn-group d-flex d-sm-none">
              <a class="fm-common-btn" routerLink="/login">Sign in</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </nav>
</header>
